import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { handleGetJobListTypes, handleGetJobTypes } from './jobTypeThunk';
import { IJobTypeList } from '~/utils/interface/jobType';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE } from '~/utils/constants/common';

export interface JobTypeState {
  filter: IFilter;
  jobTypes: Array<IJobTypeList>;
  jobTypesList: Array<IJobTypeList>;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  jobTypeId: string;
  selectedIds: Array<string>;
  menuSelectedId: string | undefined;
  openAlertDelete: boolean;
}

const initialState: JobTypeState = {
  jobTypes: [],
  jobTypesList: [],
  filter: {
    page: 1,
    limit: 0,
    search: '',
    searchFields: [],
    sort: [],
  },
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  jobTypeId: '',
  selectedIds: [],
  menuSelectedId: undefined,
  openAlertDelete: false,
};

interface IFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const jobTypeSlice = createSlice({
  name: 'jobType',
  initialState,
  reducers: {
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    changeJobTypeId(state, action: PayloadAction<string>) {
      state.jobTypeId = action.payload;
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
      if (!state.openAlertDelete) {
        state.menuSelectedId = undefined;
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetJobTypes.pending, (_state, _action) => {})
      .addCase(handleGetJobTypes.fulfilled, (state, action) => {
        state.jobTypes = [...action.payload.responses];
      })
      .addCase(handleGetJobTypes.rejected, (_state, _action) => {})

      .addCase(handleGetJobListTypes.fulfilled, (state, action) => {
        state.jobTypesList = [...action.payload.responses];
        state.needRefreshData = false;
      });
  },
});

export const jobTypeActions = jobTypeSlice.actions;

const jobTypeReducer = jobTypeSlice.reducer;
export default jobTypeReducer;
